const mapIconMapping = {
    Kooperationsverbund: {
        categoryId: 'kooperationsverbund',
        color: '#f29200',
        icon: 'IconKoopv',
        label: 'Kooperationsverbund',
        fullWidth: false,
    },
    Schule_11: {
        categoryId: 'schule',
        color: '#f19156',
        icon: 'IconSchool',
        label: 'Grundschule',
        fullWidth: false,
    },
    Schule_12_15: {
        categoryId: 'schule',
        color: '#614918',
        icon: 'IconSchool',
        label: 'Oberschule und Oberstufe+',
        fullWidth: false,
    },
    Schule_13: {
        categoryId: 'schule',
        color: '#00782c',
        icon: 'IconSchool',
        label: 'Gymnasium',
        fullWidth: false,
    },
    Schule_14: {
        categoryId: 'schule',
        color: '#750d68',
        icon: 'IconSchool',
        label: 'Gemeinschaftsschule',
        fullWidth: false,
    },
    Schule_16: {
        categoryId: 'schule',
        color: '#e600af',
        icon: 'IconSchool',
        label: 'Schule nach § 63d SächsSchulG',
        fullWidth: false,
    },
    Schule_21_22_23_24_25: {
        categoryId: 'schule',
        color: '#003788',
        icon: 'IconSchool',
        label: 'Berufsschule, Berufsfachschule, Fachschule, Fachoberschule, Berufliches Gymnasium',
        fullWidth: true,
    },
    Schule_28_31_32_33_34_35_36_37_39: {
        categoryId: 'schule',
        color: '#c1002b',
        icon: 'IconSchool',
        label: 'Berufsbildende Förderschule, Schulen mit dem Förderschwerpunkten, Klinik- und Krankenhausschule',
        fullWidth: true,
    },
    Schule_41_42_43_44: {
        categoryId: 'schule',
        color: '#f1c356',
        icon: 'IconSchool',
        label: 'Abendoberschule / Abendgymnasium / Kolleg',
        fullWidth: false,
    },
    Schule_19_29: {
        categoryId: 'schule',
        color: '#069893',
        icon: 'IconSchool',
        label: 'Ergänzungsschule',
        fullWidth: false,
    },
    Schule_c_0: {
        categoryId: 'schule',
        color: '#1A76D0',
        icon: 'IconSchool',
        label: 'Sonstige Bildungs- und Betreuungseinrichtung',
        fullWidth: false,
    },
    Schule_c_1: {
        categoryId: 'schule',
        color: '#5f5f5f',
        icon: 'IconSchool',
        label: 'Weitere Bildungseinrichtung',
        fullWidth: false,
    },
    Schule_c_2: {
        categoryId: 'schule',
        color: '#c1002b',
        icon: 'IconSchuleBeratungsstelle',
        label: 'Förderschule oder Förderzentrum mit Beratungsstelle',
        fullWidth: false,
    },
    Institution_0: {
        categoryId: 'einrichtung',
        color: '#b7d69b',
        icon: 'IconInstitutionSchulAufsicht',
        label: 'Standort der Schulaufsicht',
        fullWidth: false,
    },
    Institution_1: {
        categoryId: 'einrichtung',
        color: '#b7d69b',
        icon: 'IconInstitutionServiceStelle',
        label: 'Servicestelle Inklusionsassistenz',
        fullWidth: false,
    },
    Institution_2: {
        categoryId: 'einrichtung',
        color: '#b7d69b',
        icon: 'IconInstitutionLandesinkluClearing',
        label: 'Landesbeauftragter für Inklusion der Menschen mit Behinderung (Clearingstelle)',
        fullWidth: true,
    },
    Institution_3: {
        categoryId: 'einrichtung',
        color: '#b7d69b',
        icon: 'IconInstitutionSehbehinderung',
        label: 'Kompetenz- und Medienzentrum der Landesschule für Blinde und Sehbehinderte Chemnitz',
        fullWidth: true,
    },
    Institution_4: {
        categoryId: 'einrichtung',
        color: '#b7d69b',
        icon: 'IconLSJ',
        label: 'Unterstützungsangebot zur Umsetzung inklusiver Schulentwicklung',
        fullWidth: true,
    },
    Institution_5: {
        categoryId: 'einrichtung',
        color: '#b7d69b',
        icon: 'IconInstitutionZKI',
        label: 'Unterstützungsangebot für Kooperationsverbünde zur schulischen Inklusion bei der Netzwerkarbeit und Organisation von Veranstaltungen',
        fullWidth: true,
    },
};

export default mapIconMapping;
